import React from 'react'

import { useSchedulerConfig } from '@/components/integration/nylas/scheduler/context/SchedulerConfigContext'
import { formatTimeShort } from '@/components/integration/nylas/scheduler/helpers'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface Props {
  startDate: Date
  isSelected: boolean
  onClick: () => void
  index: number
}

const TimeslotPickerButton: React.FC<Props> = ({
  startDate,
  isSelected,
  onClick,
  index,
}) => {
  const { timezone } = useSchedulerConfig()

  return (
    <Button
      variant={isSelected ? 'outline-primary' : 'ghost'}
      size="lg"
      onClick={onClick}
      className={cn(
        'pop-in border',
        isSelected ? 'hover:text-primary bg-card hover:bg-card font-bold' : '',
      )}
      style={{
        animationDelay: `${index * 32}ms`,
        animationFillMode: 'both',
      }}
    >
      {formatTimeShort(startDate, timezone)}
    </Button>
  )
}

export default TimeslotPickerButton
